module.exports = __webpack_public_path__ + "img/zd.ab858610.jpg";